import React from 'react'

import { LeavingGuard } from '@components/utils/LeavingGuard'
import {
  Banner,
  Button,
  ButtonClean,
  Checkbox,
  Fieldset,
  Icon,
  InputUI,
  Subsection,
} from '@fourthwall/components'
import { SpotifyIcon } from '@fourthwall/icons'
import { TagSelect } from '@modules/Dashboard/Memberships/components/TagSelect'
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar'

import { usePodcastContext } from '../../hooks/usePodcastContext'
import { SyncedBar } from '../SyncedBar/SyncedBar'
import { SyncingBar } from '../SyncingBar/SyncingBar'
import * as S from './NewFields.styled'

export const NewFields = () => {
  const {
    podcast,
    tags,
    selectedTags,
    form,
    isLoading,
    handleAddTag,
    handleRemoveTag,
    handleSyncPodcast,
    handleDesyncPodcast,
  } = usePodcastContext()

  if (!podcast) return null

  return (
    <Subsection title="Add members-only audio to this podcast">
      <S.Container>
        <div>
          Allow members to listen to your audio posts on Spotify.{' '}
          <ButtonClean
            label="Learn more"
            withUnderline
            href="https://help.fourthwall.com/hc/en-us/articles/31440397820059-How-to-Share-Members-Only-Audio-Content-on-Spotify"
            target="_blank"
          />
        </div>
        {podcast.status === 'Created' && (
          <Button
            appearance="secondary"
            leftIcon={<Icon component={SpotifyIcon} height={20} />}
            iconColor="#1ed760"
            label="Sync podcast to Spotify"
            loading={isLoading}
            onClick={handleSyncPodcast}
          />
        )}
        {podcast.status === 'Syncing' && <SyncingBar loading={isLoading} />}
        {podcast.status === 'Synced' && (
          <SyncedBar
            url={podcast.spotifyUrl || ''}
            loading={isLoading}
            onClick={handleDesyncPodcast}
          />
        )}

        {/* {podcast.status === 'Synced' && (
          <span>
            To receive detailed analytics, you can{' '}
            <ButtonClean
              label="claim your podcast in Spotify"
              withUnderline
              href="https://help.fourthwall.com/hc/en-us/articles/31440397820059-How-to-Share-Members-Only-Audio-Content-on-Spotify"
              target="_blank"
            />
            .
          </span>
        )} */}
        {podcast.status === 'Errored' && (
          <SyncedBar
            url={podcast.spotifyUrl || ''}
            errored
            loading={isLoading}
            onClick={handleDesyncPodcast}
          />
        )}
        <S.FieldsetContainer>
          <Fieldset>
            {podcast.status === 'Errored' && podcast.ingestionValidationErrors && (
              <Fieldset.Row>
                <Banner appearance="danger" title={podcast.ingestionValidationErrors} />
              </Fieldset.Row>
            )}
            <Fieldset.Row>
              <Checkbox
                label="Sync only audio posts with specific tags to Spotify"
                {...form.getFieldProps('withTags')}
              />
            </Fieldset.Row>
            {form.values.withTags && (
              <Fieldset.Row inner>
                <S.TagSelectContainer>
                  <TagSelect
                    label={tags.length === 0 ? 'You haven’t created any tags yet' : 'Select tags'}
                    selectedTags={selectedTags}
                    tags={tags}
                    onAdd={handleAddTag}
                    onRemove={handleRemoveTag}
                  />
                  {form.errors.tags && <InputUI.Error>{form.errors.tags.toString()}</InputUI.Error>}
                </S.TagSelectContainer>
              </Fieldset.Row>
            )}
          </Fieldset>
        </S.FieldsetContainer>
      </S.Container>
      <ConfirmBar
        isOpen={form.dirty}
        isLoading={isLoading}
        onConfirm={form.submitForm}
        onCancel={form.resetForm}
      />
      <LeavingGuard when={form.dirty} isValid={form.isValid} onSave={form.submitForm} />
    </Subsection>
  )
}
